import DashboardIncidentMechanismBreakdownCard from './DashboardIncidentMechanismBreakdownCard';

export default DashboardIncidentMechanismBreakdownCard;
